// extracted by mini-css-extract-plugin
module.exports = {"btn":"CreateItineraryFromPinsButton_btn__vmTMK","clicked":"CreateItineraryFromPinsButton_clicked__fQhEa"};